<template>
    <div class="breadcrumb-only" :class="small ? 'small-breadcrumb' : ''">
        <div class="title" :class="small ? 'small-title' : ''">
            当前位置:&nbsp;
        </div>
        <div class="breadcrumb-list-only">
            <div class="breadcrumb-item-only breadcrumb-title" v-if="rData.type == 'nl' || rData.type == 'home' || needHome">
                &nbsp;
                <span @click="goHome">首页&nbsp;/&nbsp;</span>
            </div>
            <div class="breadcrumb-item-only" :class="validateNavigation(bread, index) ? 'c_p' : ''" v-for="(bread, index) in breadList" :key="index">
                <span v-if="index != 0">/&nbsp;</span>
                <div @click="goPath(bread, index)">
                    {{ bread.menuName }}
                </div>
                &nbsp;
            </div>
        </div>
    </div>
</template>

<script>
import { featchClickMenuDataFromLocal } from '../utils/common'

export default {
    /**
     * @property {string} needHome -是否需要首页文字
     * **/
    props: ['small', 'describe', 'describeText', 'newLink', 'needHome'],
    data() {
        return {
            breadList: [],
            screenWidth: 0,
            rData: {}, // 路由参数
        }
    },
    mounted() {
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth
            })()
        }
        this.screenWidth = document.body.clientWidth
        
    },
    watch: {
        '$route': {
            handler: function(val, old) {
                if (Object.keys(val.query).length) {
                    this.rData = val.query
                }
                if (Object.keys(val.params).length) {
                    this.rData = val.params
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        loadClickMenuDataFromLocal() {
            // 默认到顶部
            this.$returnTopPage()
            if (this.rData.type == 'home') {
                    this.breadList.push({
                        menuIdn: 'last describe',
                        menuName: this.describeText
                    })
                return
            }
            if (this.rData.type == 'nl' || this.rData.type == 'search') {
                this.breadList.push({
                        menuIdn: '-1',
                        menuName: this.rData.name
                    })
                    this.breadList.push({
                        menuIdn: 'last describe',
                        menuName: '新闻详情'
                    })
                return
            }
            featchClickMenuDataFromLocal(null, 'picture').then(res => {
                // console.log(res, 'featchClickMenuDataFromLocal');
                this.breadList = res || []
                if (this.screenWidth < 900) {
                    this.$emit('changeBgcImg', this.breadList[0].picture || this.breadList[1].picture)
                    this.changeMenuTextColor(this.breadList[0].color || this.breadList[1].color)
                }
                if (this.describe) {
                    this.breadList.push({
                        menuIdn: 'last describe',
                        menuName: this.describeText
                    })
                }
            })
        },
        goPath(bread, index) {
            // console.log(bread, index, this.breadList.length);

            if (bread.menuIdn == '-1') {
                this.$router.back()
                return
            }

            // 面包屑长度大于2并且 点击触发的大于0--(不是一级菜单)
            if (this.breadList.length >= 2 && index > 0 && index !== this.breadList.length - 1) {
                let params = {
                    name: this.breadList[0].menuIdn + '-' + bread.menuName
                }
                localStorage.setItem('choiceMenuName', bread.menuName)
                localStorage.setItem('menuIdChoice', bread.menuIdn)
                localStorage.setItem('id', this.breadList[0].menuIdn)
                localStorage.setItem('name', bread.menuName)
                
                // if (this.newLink) {
                //     const { href } = this.$router.resolve(`/navItemModel?name=${params.name}`)
                //     window.open(href, '_blank')
                // }
                if (this.rData.name !== params.name){
                    this.$router.push({
                        path: '/navItemModel',
                        query: params
                    })
                }
                console.log(params, 'lllll');
                // window.location.reload()
            }
        },
        goHome() {
            this.$router.push('/')
        },
        // 修改列表文字颜色,现在只有党政需要
        changeMenuTextColor(color) {
            // color== 2红色
            this.$nextTick(() => {
                if (color == 2) {
                    localStorage.setItem('colorType', '2')
                } else {
                    localStorage.setItem('colorType', '1')
                }
            })

        },
        validateNavigation(bread, index) {
           let name = this.breadList[0].menuIdn + '-' + bread.menuName
           let firstBoolean =  this.breadList.length >= 2 && index > 0 && index !== this.breadList.length - 1
           let secondBollean = this.rData.name !== name // 不是当前路由
           return secondBollean && firstBoolean
        }
    }
}
</script>

<style scoped>
.breadcrumb-only,
.breadcrumb-list-only, .breadcrumb-item-only {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    color: #fff;
    flex-wrap: wrap;
    justify-content: flex-start!important;
}
.small-breadcrumb, .small-breadcrumb .breadcrumb-list-only, .small-breadcrumb .breadcrumb-item-only {
    font-weight: 500;
    font-size: 16px;
    color: #444444;
    line-height: 19px;
}
.breadcrumb-title {
    cursor: pointer;
}

@media screen and (max-width: 900px) {
    .small-breadcrumb, .small-breadcrumb .breadcrumb-list-only, .small-breadcrumb .breadcrumb-item-only {
        font-size: 12px;
    }
    .breadcrumb-only {
        justify-content: flex-start;
    }
    .small-breadcrumb, .small-breadcrumb .breadcrumb-list-only, .small-breadcrumb .breadcrumb-item-only {
        font-size: 16px;
        line-height: 19px;
    }
}
.breadcrumb-only {
    margin: 0;
    justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/breadcrumbComponent.vue